import { getData } from '../../../common/utils/network.utils';

export const fetchMetaData = async () => {
    return (await getData('metadata')).data;
}